import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'requestFileStatus',
    pure: false,
})
export class RequestFileStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(status: number): any {
        switch (status) {
            case 1:
                return this.translateService.instant('Not created');
            case 2:
                return this.translateService.instant('Available');
            case 3:
                return this.translateService.instant('Deleted');
            default:
                return '';
        }
    }
}
